import {
  default as AntSelect,
  SelectProps as Props,
  SelectValue,
} from "antd/lib/select";

import React from "react";

export function Select<A extends SelectValue>({
  children,
  ...props
}: Props<A>) {
  return <AntSelect<A> {...props}>{children}</AntSelect>;
}

export namespace Select {
  export const OptionGroup = AntSelect.OptGroup;
  export const Option = AntSelect.Option;
}
